"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rejectSession = exports.stopSession = exports.hideSession = exports.onWebRTCEventSessionClose = exports.onWebRTCEventSessionStart = exports.onWebRTCEventDelayed = exports.onWebRTCEvent = exports.CallSessionList$ = void 0;
var effector_1 = require("effector");
var types_1 = require("../types");
// todo remove circular_dependency
var index_1 = require("../index");
exports.CallSessionList$ = effector_1.createStore({});
exports.onWebRTCEvent = effector_1.createEvent();
exports.onWebRTCEventDelayed = effector_1.createEvent();
exports.onWebRTCEventSessionStart = effector_1.createEvent();
exports.onWebRTCEventSessionClose = effector_1.createEvent();
exports.hideSession = effector_1.createEvent();
exports.onWebRTCEventDelayed.watch(function () {
    var a = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        a[_i] = arguments[_i];
    }
    return setTimeout(function () { return exports.onWebRTCEvent.apply(void 0, a); }, 0);
});
var peerConnectionsHasState = function (expectedState, session) {
    var arr = Object.values(session.peerConnections);
    return arr.reduce(function (a, b) {
        return a ||
            b.connectionState === expectedState ||
            b.iceConnectionState === expectedState;
    }, false);
};
var mapSessionToState = function (session) {
    // outgoing active call
    if (session.initiatorID === session.currentUserID &&
        session.state === types_1.TSessionState.ACTIVE &&
        (peerConnectionsHasState('connected', session) ||
            peerConnectionsHasState('connecting', session))) {
        return types_1.TRoxySessionState.ACTIVE;
    }
    // outgoing call
    if (session.initiatorID === session.currentUserID &&
        session.state === types_1.TSessionState.ACTIVE &&
        peerConnectionsHasState('new', session)) {
        return types_1.TRoxySessionState.OUTGOING;
    }
    if (session.opponentsIDs.includes(session.currentUserID) &&
        session.state === types_1.TSessionState.NEW) {
        return types_1.TRoxySessionState.INCOMING;
    }
    if (session.opponentsIDs.includes(session.currentUserID) &&
        session.state === types_1.TSessionState.ACTIVE) {
        return types_1.TRoxySessionState.ACTIVE;
    }
    return types_1.TRoxySessionState.INACTIVE;
};
exports.CallSessionList$.on(exports.onWebRTCEvent, function (store, session) {
    var _a;
    var newSessionState = { session: session, state: mapSessionToState(session) };
    return __assign(__assign({}, store), (_a = {}, _a[session.ID] = newSessionState, _a));
});
exports.CallSessionList$.on(exports.hideSession, function (store, session) {
    var _a;
    var newSessionState = { session: session, state: types_1.TRoxySessionState.INACTIVE };
    return __assign(__assign({}, store), (_a = {}, _a[session.ID] = newSessionState, _a));
});
var sendCallInfoMessage = function (session) { return __awaiter(void 0, void 0, void 0, function () {
    var isMissedCall, callDurationTimeSeconds, isVideo, message, dialogs;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                isMissedCall = !session.callAcceptedTimestampRoxy;
                callDurationTimeSeconds = !isMissedCall
                    ? "" + (Date.now() - session.callAcceptedTimestampRoxy) / 1000
                    : '-1';
                isVideo = session.callType === types_1.TWebRTCMediaType.VIDEO;
                message = isMissedCall
                    ? "" + (isVideo ? 'Missed Video Call' : 'Missed Audio Call')
                    : (isVideo ? 'Video Call' : 'Audio Call') + " " + callDurationTimeSeconds + "s";
                return [4 /*yield*/, index_1.Dialogs.get()];
            case 1:
                dialogs = _a.sent();
                session.opponentsIDs
                    .filter(function (userId) { return userId !== session.currentUserID; })
                    .forEach(function (userId) {
                    var dialog = dialogs.items.find(function (d) {
                        return d.occupants_ids.includes(userId);
                    });
                    if (!dialog) {
                        return;
                    }
                    index_1.Messages.sendMessage(dialog._id)({
                        message: message,
                        customParams: { callInfo: '1', callDurationTimeSeconds: callDurationTimeSeconds },
                    });
                });
                return [2 /*return*/];
        }
    });
}); };
var sendCallStartMessage = function (session) { return __awaiter(void 0, void 0, void 0, function () {
    var isVideo, message, dialogs;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                isVideo = session.callType === types_1.TWebRTCMediaType.VIDEO;
                message = "" + (isVideo ? types_1.CALL_MESSAGES.INCOMING_VIDEO : types_1.CALL_MESSAGES.INCOMING_AUDIO);
                return [4 /*yield*/, index_1.Dialogs.get()];
            case 1:
                dialogs = _a.sent();
                session.opponentsIDs
                    .filter(function (userId) { return userId !== session.currentUserID; })
                    .forEach(function (userId) {
                    var dialog = dialogs.items.find(function (d) {
                        return d.occupants_ids.includes(userId);
                    });
                    if (!dialog) {
                        return;
                    }
                    index_1.Messages.sendMessage(dialog._id)({
                        message: message,
                        customParams: { callInfo: '1' },
                    });
                });
                return [2 /*return*/];
        }
    });
}); };
exports.onWebRTCEventSessionStart.watch(function (session) {
    var rest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        rest[_i - 1] = arguments[_i];
    }
    sendCallStartMessage(session);
    exports.onWebRTCEvent.apply(void 0, __spreadArrays([session], rest));
});
exports.onWebRTCEventSessionClose.watch(function (session) {
    var rest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        rest[_i - 1] = arguments[_i];
    }
    exports.onWebRTCEvent.apply(void 0, __spreadArrays([session], rest));
    sendCallInfoMessage(session);
});
exports.stopSession = function (session) {
    setTimeout(function () { return exports.hideSession(session); }, 300);
    session.stop({});
};
exports.rejectSession = function (session) {
    setTimeout(function () { return exports.hideSession(session); }, 300);
    session.reject({});
};
//# sourceMappingURL=sessionStore.js.map